import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconSvgComponent } from 'src/app/shared/component/icon/svg-icon.component';
import { IconsConstants } from 'src/app/shared/common';
import { 
  GetUnseenNotificationsCountEvent, 
  GetUnseenNotificationsCountReadyState, 
  MarkNotificationAsReadSucessState, 
  NotificationsBloc, 
  NotificationsState 
} from '../bloc/notifications-bloc';
import { takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/shared/component/base-component/base.component';
import { PushNotificationService } from 'src/app/core/services/push-notification.service';
import { NotificationsSidebarService } from 'src/app/core/services/notifications-sidebar-service';

@Component({
  selector: 'app-notifications-button',
  standalone: true,
  imports: [
    CommonModule,
    IconSvgComponent
  ],
  templateUrl: './notifications-button.component.html',
  styleUrls: ['./notifications-button.component.scss'],
  providers: [NotificationsBloc]
})
export class NotificationsButtonComponent extends BaseComponent implements OnInit {
  unreadNotificationsCount: number;
  @Output() openNotificationCenterEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  //constants
  IconsConstants = IconsConstants;

  constructor(
    injector: Injector, 
    private notificationsBloc: NotificationsBloc,  
    private PushNotificationService: PushNotificationService,
    private notificationsSidebarService: NotificationsSidebarService
  ) {
    super([], injector);
    this.notificationsBloc.onState.pipe(takeUntil(this.destroy$)).subscribe(state => this.onHandleNotificationsState(state));
    this.notificationsSidebarService.unseenNotificationCount$.pipe(takeUntil(this.destroy$)).subscribe(count => this.unreadNotificationsCount = count)
   }

  ngOnInit(): void {
    this.getUnseenNotificationsCount();
    this.handleNotificationUpdate();
    this.handleNotificationsInBackground();
  }

  openNotificationCenter(): void {
    this.notificationsSidebarService.openSideNavBar();
  }

  private getUnseenNotificationsCount(): void {
    this.notificationsBloc.setEvent.next(new GetUnseenNotificationsCountEvent());
  }

  private onHandleNotificationsState(state: NotificationsState): void {
    if(state instanceof GetUnseenNotificationsCountReadyState) {
      this.unreadNotificationsCount = state.count;
    } else if (state instanceof MarkNotificationAsReadSucessState) {
      this.unreadNotificationsCount = state.unseenNotificationCount;
   }
  }

  private handleNotificationsInBackground(): void {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'UPDATE_UNSEEN_NOTIFICATION_COUNT') {
        this.getUnseenNotificationsCount();
      }
    });
  }

  private handleNotificationUpdate(): void {
    this.PushNotificationService.notificationUpdate$
    .pipe(takeUntil(this.destroy$))
    .subscribe((notification) => {
      if(notification) {
        this.getUnseenNotificationsCount();
      }
    })
  }
}
